// ============================================================================
// TRIMA CONSTANTS — Isolated module
// ============================================================================

/**
 * LocalStorage key for the encrypted Trima flow state.
 * Prefixed to make it obvious in dev tools and easy to grep when removing.
 */
export const TRIMA_STORAGE_KEY = 'trima_flow_state_v1';

/**
 * Encryption key used by trimaEncryption.ts.
 * NOTE: this is intentionally obfuscation-grade, not security-grade. The threat
 * model is "prevent casual inspection in dev tools", not "protect against an
 * attacker with code access". The key lives in the bundle.
 *
 * If we ever upgrade to real security, derive this from user.id at runtime
 * and rotate per session.
 */
export const TRIMA_ENCRYPTION_KEY = 'trima-fe-obfuscation-key-v1';

/**
 * Total number of cadrans in the parcours. Used for "Cadran X / 4" counter
 * and for computing global progression.
 */
export const TRIMA_TOTAL_CADRANS = 4;

/**
 * Total number of "steps" for the global progress counter:
 * - Step 1 = ranking phase
 * - Step 2 = all 4 cadrans (treated as one step)
 */
export const TRIMA_TOTAL_STEPS = 2;

/**
 * Mock toggle — when true, the API hook returns mock data instead of hitting
 * the BE. Flip to false (or remove the mock path entirely) when the real BE
 * endpoints are ready.
 *
 * Mocks live in pages/questionnaire-trima/mocks/.
 */
export const TRIMA_USE_MOCKS = false;

/**
 * The ComColors questionnaire ID for the competences questionnaire.
 * Used in all three Trima API endpoints.
 */
export const TRIMA_QUESTIONNAIRE_ID = 19;

/**
 * Minimum number of items the user must select per cadran.
 * Cadrans 1 & 3 require 10 selections; cadrans 2 & 4 require 5.
 * The BE does not return this value — it's a product-level constant.
 */
import type { TrimaCadranNumber } from 'pages/questionnaire-trima/types/trima.types';
export const CADRAN_MIN_SELECTIONS: Record<TrimaCadranNumber, number> = {
  1: 10,
  2: 5,
  3: 10,
  4: 5,
};
